const PROJECT_NAME = "NodeJS Web Server Framework(Vue)";
const PROJECT_VERSION = "1.0";
const BASE_DIR = __dirname;
const LOG_BASE_DIR = `${__dirname}/server/logs`;
const SERVICE_STATUS = process.env.NODE_ENV; //development, production
const PORT = 8083;
// process.env는 .env 파일의 환경변수를 통해 가져옴
// 백엔드(API) 서버 (미설정 시 로컬 기본값)
const API_SERVER_HOST = process.env.API_SERVER_HOST || "localhost:9083";

// 현재 시스템 구분
const SYSTEM_CODE = "GB";

// 연동 BI 시스템 (미설정 시 로컬 기본값)
const BI_DOMAIN = process.env.BI_DOMAIN || "localhost";
const BI_API_SERVER_HOST = process.env.BI_API_SERVER_HOST || `${BI_DOMAIN}:9082`; // BI backend
const BI_WEB_SERVER_HOST = process.env.BI_WEB_SERVER_HOST || `${BI_DOMAIN}:8082`; // BI frontend

module.exports = {
  PROJECT_NAME,
  PROJECT_VERSION,
  BASE_DIR,
  LOG_BASE_DIR,
  SERVICE_STATUS,
  PORT,
  API_SERVER_HOST,
  SYSTEM_CODE,
  BI_DOMAIN,
  BI_API_SERVER_HOST,
  BI_WEB_SERVER_HOST,
};
